import axios from 'axios';
import { useToast } from 'vue-toastification';


const toast = useToast();

const state = {
  user: null,
  token: null,
};

const getters = {
  isAuthenticated: state => !!state.user,
  stateUser: state => state.user,
  stateToken: state => state.token,
  stateRefreshToken: state => state.refreshToken,
  stateValidToken: state => state.validToken,
};

const actions = {
  // eslint-disable-next-line no-empty-pattern
  async register({}, form) {
    try {
      let first_name = form.full_name.split(" ")[0];
      let last_name = form.full_name.split(" ")[1] || '';
      form.first_name = first_name;
      form.last_name = last_name;
      delete form.full_name;
      await axios.post('/users/add', form);
      let UserForm = new FormData();
      UserForm.append('email', form.email);
      UserForm.append('password', form.password);
      UserForm.append('first_name', first_name);
      UserForm.append('last_name', last_name);
      toast.success('Usuario registrado. Checa tu correo para activar tu cuenta');
      return true;
    } catch (error) {
      // console.error('Error registering user:', error);
      toast.error('Error al registrar el usuario');
      return false;
    }
    
    //await dispatch('logIn', UserForm);
  },
  async logIn({dispatch, commit}, user) {
    //console.log(JSON.stringify(user));
   
    try {
      const logged_user = await axios.post('auth/get_token', user);
      if (!logged_user.data.access_token) {
        toast.error(logged_user.data.message || 'Solicitud incorrecta');
        return;
      }
      if (!logged_user.data.access_token) {
        // show error in UI
        toast.error('Credenciales Incorrectas');
        return;
      }
      await commit('setToken', logged_user.data.access_token);
      await commit('setRefreshToken', logged_user.data.refresh_token);
      await dispatch('viewMe');
    } catch (error) {

      console.error('Error logging in:', error);
      toast.error('Error al iniciar sesión');
    }
  },
  async viewMe({commit}) {
    let {data} = await axios.get('users/whoami');
    await commit('setUser', data.data);
  },
  // eslint-disable-next-line no-empty-pattern
  async deleteUser({}, id) {
    await axios.delete(`user/${id}`);
  },
  async logOut({commit}) {
    let user = null;
    commit('logout', user);
  },
  async refreshToken({commit}, refreshToken) {
    try {
      const response = await axios.post('/auth/refresh_token', {
        refresh_token: refreshToken,
      });
      await commit('setToken', response.data.access_token);
      await commit('setRefreshToken', response.data.refresh_token);
      return response.data.access_token;
    } catch (error) {
      console.error('Failed to refresh token', error);
      throw error;
    }
  },

  async validateToken({commit}, token) {
    try {
      const response = await axios.get(`/auth/validate_account/${token}`);
      await commit('setValidToken', true);
      return response.data;
    } catch (error) {
      console.error('Failed to validate token', error);
      await commit('setValidToken', false);
    }
  }
};

const mutations = {
  setUser(state, email) {
    state.user = email;
  },
  setToken(state, token) {
    state.token = token;
    localStorage.setItem('token', token);
  },
  setRefreshToken(state, refreshToken) {
    state.refreshToken = refreshToken;
    localStorage.setItem('refreshToken', refreshToken);
  },
  setValidToken(state, validToken) {
    state.validToken = validToken;
  },
  logout(state, user){
    state.user = user;
    state.token = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
